import { useEffect, useState } from "react";

export const isFrontend = () => {
  const [frontend, setFrontend] = useState(false);
  useEffect(() => setFrontend(true));
  return frontend;
};
